/* tslint:disable */
/* eslint-disable */
/**
 * Organization & Workspace Gateway
 * Methods to manage all organizations and workspaces
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    WorkspaceMemberStatus,
    WorkspaceMemberStatusFromJSON,
    WorkspaceMemberStatusFromJSONTyped,
    WorkspaceMemberStatusToJSON,
} from './';

/**
 * 
 * @export
 * @interface WorkspaceMember
 */
export interface WorkspaceMember {
    /**
     * A workspace member unique identifier.
     * @type {string}
     * @memberof WorkspaceMember
     */
    workspaceMemberId: string;
    /**
     * The time at which the workspace member was initially invited.
     * @type {Date}
     * @memberof WorkspaceMember
     */
    createdAt: Date;
    /**
     * The email address of the workspace member.
     * @type {string}
     * @memberof WorkspaceMember
     */
    email?: string;
    /**
     * 
     * @type {WorkspaceMemberStatus}
     * @memberof WorkspaceMember
     */
    status: WorkspaceMemberStatus;
}

export function WorkspaceMemberFromJSON(json: any): WorkspaceMember {
    return WorkspaceMemberFromJSONTyped(json, false);
}

export function WorkspaceMemberFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkspaceMember {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'workspaceMemberId': json['workspaceMemberId'],
        'createdAt': (new Date(json['createdAt'])),
        'email': !exists(json, 'email') ? undefined : json['email'],
        'status': WorkspaceMemberStatusFromJSON(json['status']),
    };
}

export function WorkspaceMemberToJSON(value?: WorkspaceMember | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'workspaceMemberId': value.workspaceMemberId,
        'createdAt': (value.createdAt.toISOString()),
        'email': value.email,
        'status': WorkspaceMemberStatusToJSON(value.status),
    };
}


